<template>
  <main class="main about max-width amateur">
    <article>
      <h1 class="title-medium">Chi siamo</h1>

      <p data-aos="fade-up" class="aos-init aos-animate">La nostra storia inizia nel lontano 1935 quando il capostipite della famiglia, Oreste, si trasferisce dalla sua città natale, Novara, a Milano per lavorare presso una importante casa editrice musicale, dove poi diventerà direttore e vi lavorerà fino al 1970.</p>

      <figure data-aos="fade-up" class="aos-init aos-animate">
        <img src="/themes/caramba/assets/images/about/edizioni_Caramba_nel_1935_oreste_si_trasferisce_a_milano.jpg">
        <figcaption>Oreste Corechà di fronte al duomo di Milano, nella città dove fonderà Edizioni Caramba</figcaption>
      </figure>

      <p data-aos="fade-up" class="aos-init">Quell’anno fonda le Edizioni Caramba e con lui, qualche anno dopo finito gli studi, inizierà il figlio Maurizio: in quegli anni i primi successi, Bongusto con "Il nostro amore segreto", El Pasador con la sigla e le musiche della trasmissione televisiva "La sberla", le musiche per le commedie di Piero Mazzarella ed altro.</p>

      <div class="col-3">
        <figure data-aos="fade-up" data-aos-delay="0" class="aos-init">
          <img src="/themes/caramba/assets/images/about/il_teatro_comico_di_piero_mazzarella.jpg">
          <figcaption>La locandina del “Dò donzenn de Spin” di Piero Mazzarella, con le musiche edite da Caramba</figcaption>
        </figure>
        <figure data-aos="fade-up" data-aos-delay="200" class="aos-init">
          <img src="/themes/caramba/assets/images/about/edizioni_caramba_i_classici_di_fred.jpg">
          <figcaption>La copertina del numero 6 de “I Classici Di Fred” stampato e diffuso da Edizioni Musicali Caramba</figcaption>
        </figure>
        <figure data-aos="fade-up" data-aos-delay="400" class="aos-init">
          <img src="/themes/caramba/assets/images/about/edizioni_caramba_il_nostro_amor_segreto_spartito.jpg">
          <figcaption>“Il nostro amor segreto” di Fred Bongusto, originariamente pubblicato ne “I Classici Di Fred”</figcaption>
        </figure>
      </div>

      <p data-aos="fade-up" class="aos-init">Nel 1980, dopo la morte del papà, prosegue da solo Maurizio dedicandosi quasi esclusivamente alla musica da ballo, producendo i più grandi interpreti di questo genere, Franco Bastelli, Mauro Levrini, Annalisa Simeoni, Omar Codazzi e tanti altri.</p>

      <div class="col-2-spaced">
        <figure class="vertically-centered aos-init" data-aos="fade-up">
          <img src="/themes/caramba/assets/images/about/edizioni_caramba_oreste_il_giorno_della_nascita_di_maurizio.jpg">
          <figcaption>Oreste con il piccolo Maurizio</figcaption>
        </figure>
        <figure data-aos="fade-up" data-aos-delay="200" class="aos-init">
          <img src="/themes/caramba/assets/images/about/edizioni_Caramba_oreste_e_maurizio_sul_divano_Della_loro_casa_di_milano.jpg">
          <figcaption>Maurizio con il papà Oreste di cui, nel 1980, raccoglierà l’eredità alla guida di Edizioni Caramba</figcaption>
        </figure>
      </div>

      <figure class="centered-img small-img aos-init" data-aos="fade-up" data-aos-delay="400">
        <img src="/themes/caramba/assets/images/about/edizioni_Caramba_oreste_con_il_piccolo_maurizio.jpg">
        <figcaption>Oreste e Maurizio ancora insieme</figcaption>
      </figure>

      <p data-aos="fade-up" class="aos-init">E come nella tradizione, nel 2012, anche lei dopo aver finito gli studi, la figlia Cristina (nipote di Oreste) inizia ad affiancare papà Maurizio in questo nostro lavoro, che oltre ad essere nei nostri cuori, è evidentemente nel nostro DNA.</p>

      <figure class="centered-img medium-img aos-init" data-aos="fade-up">
        <img src="/themes/caramba/assets/images/about/edizioni_caramba_cristina_e_maurizio.jpg">
        <figcaption>Maurizio e Cristina, la tradizione di Edizioni Caramba continua!</figcaption>
      </figure>

    </article>

  </main>  
</template>

<script>
export default {
  name: 'About',

  mounted() {
    document.title = 'Caramba - Chi Siamo';
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/components/About.vue